import React, { useMemo, useReducer } from 'react';

import { OnboardingContext, OnboardingActionContext } from './OnboardingContext';
import { OnboardingActionContextType, OnboardingActionTypes, SelectPlayerFlowType } from './types';
import { DEFAULT_ONBOARDING_STATE } from './consts';
import { onboardingReducer } from './reducer';

const OnboardingProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(onboardingReducer, DEFAULT_ONBOARDING_STATE);

  const setInFlow = (inFlow: boolean) => {
    dispatch({
      type: OnboardingActionTypes.SET_IN_FLOW,
      inFlow,
    });
  };

  const setFlowType = (flowType: SelectPlayerFlowType) => {
    dispatch({
      type: OnboardingActionTypes.SET_FLOW_TYPE,
      flowType,
    });
  };

  const setIsTemplateMode = (isTemplateMode: boolean) => {
    dispatch({
      type: OnboardingActionTypes.SET_IS_TEMPLATE_FLOW,
      isTemplateMode,
    });
  };

  const resetState = () => {
    dispatch({
      type: OnboardingActionTypes.RESET_STATE,
    });
  };

  const actionContextValue: OnboardingActionContextType = useMemo(
    () => ({
      setInFlow,
      setFlowType,
      setIsTemplateMode,
      resetState,
    }),
    [setInFlow, setFlowType, setIsTemplateMode, resetState]
  );

  return (
    <OnboardingContext.Provider value={state}>
      <OnboardingActionContext.Provider value={actionContextValue}>{children}</OnboardingActionContext.Provider>
    </OnboardingContext.Provider>
  );
};

export default OnboardingProvider;
